import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { HeaderText, Button, Text } from '@el8/vital';
import { Box } from 'components';
import { PracticeInfo } from 'types';
import { getAppointmentPhone } from 'utils/practice';

import { Appointment } from 'EntityTypes';
import styles from './AppointmentManager.less';

type AppointmentAlreadyCanceledOwnProps = {
  appointment: Appointment;
  practice: PracticeInfo;
} & RouteComponentProps;

const AppointmentAlreadyCanceled = ({
  appointment,
  practice,
}: AppointmentAlreadyCanceledOwnProps) => {
  return (
    <Box className={styles.container} direction="column" align="center">
      <HeaderText
        className={styles.title}
        legacyVariant="legacyTitleText"
        sizing="heading-lg"
        tag="h1"
      >
        This appointment has already been canceled
      </HeaderText>

      {practice.settings.patientBookingEnabled ? (
        <Box className={styles.actions} direction="row" justify="center" align="center">
          <Button
            isAnchor
            href={`${window.el8Globals.BASE_URL}/book/${practice.settings.slug}`}
            className={styles.primaryButton}
            kind="primary"
          >
            Book an appointment
          </Button>
        </Box>
      ) : (
        <Box className={styles.actions} direction="row">
          <Text className={styles.text}>
            {`If you need to rebook please call the practice at ${getAppointmentPhone(
              appointment,
              practice,
            )}`}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default AppointmentAlreadyCanceled;
